import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import store from "./store";
import * as axios from "./api/http";
import "./assets/css/base.css";
import "./assets/css/reset.css";
import 'animate.css';
import "./plugins/set-DOMPurify";
import * as echarts from 'echarts';
import "./plugins/visibilitychange.js";
import VuePhotoZoomPro from 'vue-photo-zoom-pro';
Vue.config.productionTip = false;
Vue.prototype.$axios = axios; // ajax请求方法
Vue.prototype.$echarts = echarts;
Vue.use(ElementUI);
Vue.use(VuePhotoZoomPro);
new Vue({
  router,
  store,
  axios,
  render: h => h(App)
}).$mount("#app");